import { render, staticRenderFns } from "./ListCoverSettled.vue?vue&type=template&id=054bd262"
import script from "./ListCoverSettled.vue?vue&type=script&lang=js"
export * from "./ListCoverSettled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports